// extracted by mini-css-extract-plugin
module.exports = {"container":"HeroList_container__1d_v8","arrow":"HeroList_arrow__3dYVK"};